import React, { useState } from "react";
import { Ticket, Copy, Check } from "lucide-react";

const ChaizCouponCard = () => {
  const [copied, setCopied] = useState(false);

  const handleCopyCode = () => {
    navigator.clipboard.writeText("OWNLI200").then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div className="border-2 border-[#7B61FF] bg-[#F5F2FF] rounded-2xl p-5 space-y-3">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-full bg-violet-100 flex items-center justify-center flex-shrink-0 p-1.5">
          <img
            src="https://ownlicdn.blob.core.windows.net/assets/chaiz.png"
            alt="Chaiz"
            className="w-full h-full object-contain"
          />
        </div>
        <div>
          <p className="font-bold text-darkPurple text-base">
            $200 OFF ANY PLAN
          </p>
          <p className="text-sm text-gray-500">
            Use code at checkout on Chaiz
          </p>
        </div>
        <Ticket className="w-5 h-5 text-[#7B61FF] flex-shrink-0 ml-auto" />
      </div>
      <div className="flex items-center justify-between bg-white rounded-xl px-4 py-3 border border-[#7B61FF]/20">
        <span className="font-mono font-bold text-lg text-darkPurple tracking-widest">
          OWNLI200
        </span>
        <button
          onClick={handleCopyCode}
          className="flex items-center gap-1.5 text-sm font-bold text-[#7B61FF] hover:text-[#6A50EE] transition-colors"
        >
          {copied ? (
            <>
              <Check className="w-4 h-4" />
              Copied!
            </>
          ) : (
            <>
              <Copy className="w-4 h-4" />
              Copy
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default ChaizCouponCard;
